import React, { useEffect, useState } from "react";
import {
  CompanyScoreWidget,
  TargetPriceWidget,
  BrokerRatingWidget,
  TargetPriceWidgetProps,
  BrokerRatingWidgetProps,
  CompanyScoreWidgetProps,
  WidgetError,
  ThemeType,
} from "@labci/bell-fg-widgets";
import moment from "moment";

const DevPage: React.FC = () => {
  const companyScoreProps: CompanyScoreWidgetProps = {
    symbol: "AAPL.ASX",
    token: undefined,
    theme: ThemeType.Direct,
    onError: (error: WidgetError) => {
      console.log("error", error);
    },
  };
  const targetPriceProps: TargetPriceWidgetProps = {
    symbol: "AAPL.ASX",
    token: undefined,
    theme: ThemeType.Direct,
    onError: (error: WidgetError) => {
      console.log("error", error);
    },
  };
  const brokerRatingProps: BrokerRatingWidgetProps = {
    symbol: "AAPL.ASX",
    token: undefined,
    theme: ThemeType.Direct,
    onError: (error: WidgetError) => {
      console.log("error", error);
    },
  };
  return (
    <div style={{ height: "100vh" }}>
      <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
        <h1>Company Score</h1>
        <CompanyScoreWidget {...companyScoreProps} />
        <h1>Target Price</h1>
        <TargetPriceWidget {...targetPriceProps} />
        <h1>Broker Rating</h1>
        <BrokerRatingWidget {...brokerRatingProps} />
      </div>
    </div>
  );
};

export default DevPage;
